import { useEffect, useState, useContext, useMemo } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { ProfileContext as ProfileCtx } from '../../contexts/ProfileContext';
import { Link } from 'react-router-dom';
import Modal from '../../ui/Modal';
import ProjectICModal from './ProjectICModal';
import { getOrganizationMembers } from '../../apis/oragnisations/organisation';

import Heading from '../../ui/Heading';

import WhiteCard from '../../ui/WhiteCard';
import BountiesInProject from './BountiesInProject';
import { getParticularProject } from '../../apis/projects/projects';
import { getAllCertificates } from '../../apis/impactCertificates/impactCertificates';
import { useParams } from 'react-router-dom';
import Loader from '../../ui/Loader';
import { EarthIcon, FistIcon, SunIcon, WaterIcon } from '../../assets/icons/ProgressBarIcons';
import { SDG_IMAGES } from '../../constants/datas';

const coreIcons = {
    Earth: <EarthIcon key={'earth-icon'} color="" />,
    Energy: <SunIcon key="sun-icon" color="" />,
    Social: <FistIcon key={'fist-icon'} color="" />,
    Water: <WaterIcon key={'water-icon'} color="" />,
};
function ParticularProject() {
    const profileCtx = useContext(ProfileCtx);
    // const [particularOrg, orgMembers, roles, stats, fundsAllocated] = useOutletContext();
    const navigate = useNavigate();

    // ---------- ROLE / ADMIN DETERMINATION ----------
    const outletCtx = useOutletContext() || [];
    const outletRoles = outletCtx[2] || [];

    const { state: authState } = useContext(require('../../contexts/AuthContext').AuthContext) || {};
    const currentUser = authState?.user?.[0] || {};
    const userRoles = currentUser.roles || [];

    const isAdmin = outletRoles.includes('isAdmin')
    // const [isAdmin, setIsAdmin] = useState(initialAdmin);
    const { state: certificates, dispatch } = profileCtx || {};
    const [project, setProject] = useState({ certificateStatus: 'generate' });

    // verify admin via organisation members if still unknown
    // useEffect(() => {
    //     if (isAdmin || !project?.organisationId || !currentUser?.uid) return;
    //     (async () => {
    //         try {
    //             const members = await getOrganizationMembers(project.organisationId);
    //             const me = members?.find?.((m) => m.uid === currentUser.uid);
    //             if (me?.isAdmin || me?.role?.toLowerCase() === 'admin') setIsAdmin(true);
    //         } catch (err) {
    //             console.error('Failed to fetch organisation members', err);
    //         }
    //     })();
    // }, [isAdmin, project?.organisationId, currentUser?.uid]);
    const { projectId,certificateId } = useParams();

    const fetchData = async () => {
        try {
            const data = await getParticularProject(projectId);
            setProject((prev) => {
                // If we already switched to view optimistically and backend hasn't updated yet, keep view
                if (
                    prev.certificateStatus?.toLowerCase() === 'view' &&
                    (data.certificateStatus?.toLowerCase() === 'generate' || !data.certificateStatus)
                ) {
                    return { ...data, certificateStatus: 'view' };
                }
                return data;
            });
        } catch (error) {
            console.log(error);
        }
    };
    // derive status based on certificates collection
    const derivedStatus = useMemo(() => {
        if (certificates?.length) {
            const minted = certificates.some((ic) => {
                const certProjId = ic.projectId || ic.project?._id;
                return certProjId === projectId && /^(MINTED|CLAIMED)/i.test(ic.status || '');
            });
            if (minted) return 'view';
        }
        return project?.certificateStatus || 'generate';
    }, [certificates, project?.certificateStatus, projectId]);

    const renderCertificateStatus = (status = 'generate') => {
        if (!status) return null;

        const commonClasses = 'font-semibold text-[#0085FF] text-base leading-6 cursor-pointer relative z-10';

        // Normalize status coming from backend
        // const normalizedStatus = (status === 'generate' ? derivedStatus : status)?.toLowerCase();
        const normalizedStatus = 'generate'

                // until admin status resolved, do not render generate
        if (!isAdmin && normalizedStatus === 'generate') return null;
        switch (normalizedStatus) {
            case 'generate':
                return (
                    <Modal>
                        <Modal.Button opens="generateIC" className={commonClasses}>
                            Generate &rarr;
                        </Modal.Button>
                                                <Modal.Window name="generateIC">
                            <ProjectICModal
                                projectTitle={project?.title}
                                projectId={project?._id}
                                onMintSuccess={() => {
                                    // Optimistically update status to view
                                    setProject((prev) => ({ ...prev, certificateStatus: 'view' }));
                                    fetchData();
                                }}
                            />
                        </Modal.Window>
                    </Modal>
                );
            case 'mint_requested':
                return (
                    <span className={`${commonClasses} opacity-50`} aria-label="Mint requested for impact certificate">
                        Mint Requested
                    </span>
                );
            case 'minted':
            case 'minted_success':
            case 'view':
                return (
                    <Link
                        to="/profile/gallery"
                        className={commonClasses}
                        aria-label="View impact certificate"
                    >
                        View &rarr;
                    </Link>
                );
            default:
                return (
                    <Modal>
                        <Modal.Button opens="generateIC" className={commonClasses}>
                            Generate &rarr;
                        </Modal.Button>
                        <Modal.Window name="generateIC">
                            <ProjectICModal
                                projectTitle={project?.title}
                                projectId={project?._id}
                                onMintSuccess={() => {
                                    setProject((prev) => ({ ...prev, certificateStatus: 'view' }));
                                    fetchData();
                                }}
                            />
                        </Modal.Window>
                    </Modal>
                );
        }
    };

        useEffect(() => {
        // refresh certificates as well
        (async () => {
            try {
                const fresh = await getAllCertificates();
                if (dispatch) dispatch({ type: 'ic/setImpactcertificates', payload: fresh });
            } catch (e) {
                console.error('Failed to refresh certificates', e);
            }
        })();
        fetchData();
    }, [projectId]);
console.log(projectId,certificateId,project,certificates,isAdmin,outletCtx,"see this is the data here in project ")
    if (!Object.keys(project).length) return <Loader />;
    return (
        <>
            <WhiteCard className="p-6 grid grid-cols-4">
                <div className="col-span-4 mb-6">
                    <div className="mb-6">
                        <p className="font-semibold text-textSecondary">Project Title</p>
                        <Heading className={'text-textPrimary font-medium'} type={'large'}>
                            {project?.title}
                        </Heading>
                    </div>
                    <div className="flex items-center gap-9">
                        {/* Project ID */}
                        <div className="">
                            <p className="font-semibold text-textSecondary">Project ID</p>
                            <p className="font-semibold text-textPrimary uppercase">{project._id}</p>
                        </div>
                        {/* Project Impact Certificate */}
                        <div>
                        <p className="font-semibold text-textSecondary">Project Impact Certificate</p>
                        <div>
                        {
                        <div className='flex items-center gap-5'>
                           { isAdmin && <Modal>
            <Modal.Button opens="generateIC" className={`font-medium text-[#0085FF] text-base leading-6 cursor-pointer relative z-10 border-r-2 border-[#E8E8E8] pr-3`}>
                Generate &rarr;
            </Modal.Button>
            <Modal.Window name="generateIC">
                <ProjectICModal
                projectDescription={project?.description}
                    projectTitle={project?.title}
                    projectId={project?._id}
                    projectStartDate = {project?.projectStartDate}
                    onMintSuccess={() => {
                        setProject((prev) => ({ ...prev, certificateStatus: 'view' }));
                        fetchData();
                    }}
                />
            </Modal.Window>
                            </Modal>}
                            <p onClick={() => navigate(`/profile/gallery/projectic/${project?._id}?projectTitle=${project?.title}&liveStats=true`)} className={`font-medium text-[#0085FF] text-base leading-6 cursor-pointer relative z-10 ${isAdmin?"px-3":""}  `} >View Live Stats</p>
                           {isAdmin && <p onClick={() => navigate(`view-certificates`)} className={`font-medium text-[#0085FF] text-base leading-6 cursor-pointer relative z-10 border-l-2 border-[#E8E8E8] pl-3`}  >View All Certficates</p>}
                        </div>
                        }

                        </div>
                     

                        </div>
                      
                      
                    </div>
                </div>

                <div className="col-span-2">
                    <p className="font-semibold text-textSecondary">Project Description</p>
                    <p className="text-textPrimary ">{project.description}</p>
                </div>
                <div className="col-span-2 flex justify-between gap-16">
                    <div className=" w-[50%]">
                        <p className="font-semibold text-textSecondary">Impact Cores</p>
                        <div className="flex  items-center">
                            {project?.impactMetrics?.cores?.map((core) => coreIcons[core])}
                        </div>
                    </div>

                    <div className=" w-[50%]">
                        <p className="font-semibold text-textSecondary">SDGs</p>
                        <div className="grid grid-cols-3 gap-[5px]">
                            {project?.impactMetrics?.SDGs?.map((sdg, index) => (
                                <img key={sdg + index + Math.random()} className=" " src={SDG_IMAGES[sdg]} alt="" />
                            ))}
                        </div>
                    </div>
                </div>
            </WhiteCard>
            <BountiesInProject projectTitle={project?.title} />
        </>
    );
}

export default ParticularProject;
